import { Controller } from "@hotwired/stimulus"

// Keeps the greeting of a wysiwyg message ("Bonjour [PRENOM]," → "Bonjour
// Bryan,") in sync with a first-name field of the same form, so nobody has to
// edit it by hand. Only a greeting still matching the last value written is
// rewritten: once someone edits it, it is left alone.
export default class extends Controller {
  static values = {
    firstNameField: String,
    token: String,
    // The greeting line, with %{first_name} where the name goes.
    template: { type: String, default: "%{first_name}," }
  }

  connect () {
    this.current = this.tokenValue
    this.form = this.element.closest("form") || this.element
    this.sync = this.sync.bind(this)
    this.form.addEventListener("input", this.sync)
    this.form.addEventListener("change", this.sync)
    // The wysiwyg controller below may connect after this one.
    this.timeout = setTimeout(this.sync, 0)
  }

  disconnect () {
    clearTimeout(this.timeout)
    this.form.removeEventListener("input", this.sync)
    this.form.removeEventListener("change", this.sync)
  }

  sync () {
    const quill = this.quill
    if (!quill) return

    const name = this.firstName || this.tokenValue
    if (name === this.current) return

    const currentGreeting = this.greeting(this.current)
    if (quill.getText(0, currentGreeting.length) !== currentGreeting) return

    quill.deleteText(0, currentGreeting.length, "api")
    quill.insertText(0, this.greeting(name), "api")
    this.current = name
  }

  greeting (name) {
    return this.templateValue.replace("%{first_name}", name)
  }

  get firstName () {
    return document.getElementById(this.firstNameFieldValue)?.value?.trim() || ""
  }

  get quill () {
    const element = this.element.querySelector("[data-controller~='wysiwyg']")
    if (!element) return null

    return this.application.getControllerForElementAndIdentifier(element, "wysiwyg")?.quill
  }
}
